import PNLogo from '@propertypal/shared/src/resources/logos/property-news-logo.svg?url';
import PropertyPalLogo from '@propertypal/shared/src/resources/logos/PropertyPalLogo@3x.png';
import {
  IPropertyPalTerm,
  IPropertyPalPrivacyPolicy,
  IPropertyPalCookiePolicy,
  IPropertyPalProductTerm,
  IMembershipTerm,
  IPropertyNewsTerm,
} from '@propertypal/shared/src/types/strapi';
import platform from '@propertypal/shared/src/utils/platform';
import dayjs from 'dayjs';
import React from 'react';
import { Container, Logo, Policy, PolicyContainer, TitleHeader } from './PolicyContent.style';

type PolicyContentProps = Omit<
  IPropertyPalTerm['attributes'] &
    IPropertyNewsTerm['attributes'] &
    IPropertyPalPrivacyPolicy['attributes'] &
    IPropertyPalCookiePolicy['attributes'] &
    IMembershipTerm['attributes'] &
    IPropertyPalProductTerm['attributes'],
  'ROI'
> & {
  showBothLogos?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  ROI?: IMembershipTerm['attributes']['ROI'];
};

const PolicyContent: React.FC<PolicyContentProps> = ({ header, subHeader, content, updatedAt, showBothLogos }) => {
  return (
    <Container data-testid="policy-content">
      <TitleHeader data-testid="policy-logos">
        {(platform.type === 'propertypal' || showBothLogos) && (
          <Logo src={PropertyPalLogo.src} width={256} height={68} alt="PropertyPal logo" data-testid="pp-logo" />
        )}
        {(platform.type === 'propertynews' || showBothLogos) && (
          <Logo src={PNLogo.src} width={254} height={35} alt="Propertynews logo" data-testid="pn-logo" />
        )}
      </TitleHeader>

      <Policy>
        {header && <h1 data-testid="policy-header">{header}</h1>}
        {subHeader && <h1 data-testid="policy-subheader">{subHeader}</h1>}
        <small data-testid="policy-updated">Last updated: {dayjs(updatedAt).format('DD MMMM YYYY')}</small>
        {content && <PolicyContainer html={content} />}
      </Policy>
    </Container>
  );
};

export default PolicyContent;
